import { useMemo, useState } from 'react';
export function useAccountsPayableFilter(initialFilters, resetFilters) {
    const [operationCode, setOperationCode] = useState(initialFilters?.operationCode);
    const [startAt, setStartAt] = useState(initialFilters?.startAt);
    const [endAt, setEndAt] = useState(initialFilters?.endAt);
    const [minAmount, setMinAmount] = useState(initialFilters?.minAmount);
    const [maxAmount, setMaxAmount] = useState(initialFilters?.maxAmount);
    const disabledClearFilters = useMemo(() => {
        return (operationCode === resetFilters?.operationCode &&
            startAt === resetFilters?.startAt &&
            endAt === resetFilters?.endAt &&
            minAmount === resetFilters?.minAmount &&
            maxAmount === resetFilters?.maxAmount);
    }, [operationCode, startAt, endAt, minAmount, maxAmount, resetFilters]);
    const disabledApplyFilters = useMemo(() => {
        return (operationCode === initialFilters?.operationCode &&
            startAt === initialFilters?.startAt &&
            endAt === initialFilters?.endAt &&
            minAmount === initialFilters?.minAmount &&
            maxAmount === initialFilters?.maxAmount);
    }, [operationCode, startAt, endAt, minAmount, maxAmount, initialFilters]);
    return {
        operationCode,
        setOperationCode,
        startAt,
        setStartAt,
        endAt,
        setEndAt,
        minAmount,
        setMinAmount,
        maxAmount,
        setMaxAmount,
        disabledClearFilters,
        disabledApplyFilters,
    };
}
